export default __webpack_public_path__ + "static/media/EksellDisplayMedium.c79cb426.otf";